import RetriggerFreespins from "slotworks/state-machine/standard/states/retrigger-freespins";
import { sequence, parallel } from "slotworks/utils/race-utils";
import { FadeSymbolsCommand, RestoreSymbolsCommand } from "commands/symbols-commands";
import Components from "slotworks/components/components";
import Contract from "slotworks/utils/contract";
import CelebrateScatterCommand from "commands/celebrate-scatter-command";
import deviceInfo from "slotworks/utils/device-info";
import Layers from "slotworks/graphics/layers/layers";
import soundManager from "slotworks/sound/sound-manager";
import gameState from "slotworks/model/game-state";

export default class G288RetriggerFreespins extends RetriggerFreespins {
    public onEnter() {
        const record = gameState.getCurrentGame().getCurrentRecord();
        sequence([
            () => FadeSymbolsCommand(Components.matrix.getAllSymbols(), "SCATTER"),
            () => Contract.getTimeoutContract(100),
            () => new Contract(resolve => {
                if(record.results.length == 1) {
                    parallel([
                        () => Components.celebrateWin.additionalWin(record.creditsWon),
                        () => CelebrateScatterCommand()
                    ]).then(resolve);
                } else {
                    CelebrateScatterCommand().then(resolve);
                }
            })
        ])
        .then(() => {
            if(!deviceInfo.isDesktop) Layers.SmartButton.hide();
            Layers.CelebrationBackground.setScene("freespins").execute();
            super.onEnter();
            RestoreSymbolsCommand(Components.matrix.getAllSymbols());
        });
    }

    public complete() {
        soundManager.customEvent("freespins_music");
        Layers.CelebrationBackground.defaultScene().execute();
        Layers.SmartButton.show();
        super.complete();
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/retrigger-freespins.ts